<template>
    <div>

        <!-- Header Start -->
        <div style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="flex-wrap">
            <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">QR Distribution Monitoring</h2>
        </div>
        <!-- Header End -->

        <!-- Stats Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">Distribution Overview</h3>
            <div class="row stats-row">
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-awal.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Saldo Awal</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">{{ data.stats ? numberWithCommas(data.stats.qty_before) : 'Loading...' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/in-transit-md.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">In Transit Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">{{ data.stats ? numberWithCommas(data.stats.qty_intransit) : 'Loading...' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-md.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Diterima Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">{{ data.stats ? numberWithCommas(data.stats.qty_received) : 'Loading...' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">QR Dipakai</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">{{ data.stats ? numberWithCommas(data.stats.qty_mapping) : 'Loading...' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-akhir.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Saldo Akhir</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">{{ data.stats ? numberWithCommas(data.stats.qty_after) : 'Loading...' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Stats End -->
        
        <deliveryDetailTable></deliveryDetailTable>
        <distributionSummaryTable></distributionSummaryTable>
        <mapping-detail-table></mapping-detail-table>
    </div>
</template>

<script>
import debounce from 'debounce';
import moment from 'moment';

import deliveryDetailTable from './children/deliveryDetailTable.vue'
import distributionProjection from './children/distributionProjectionChart.vue'
import mappingDetailTable from './children/mappingDetailTable.vue'
import distributionSummaryTable from './children/distributionSummaryTable.vue';

export default {
    metaInfo : {
        title : 'Distribution Monitoring'
    },
    data () {
        let start = moment().format("YYYY-MM-DD");
        let end = moment().format("YYYY-MM-DD");
        return {
            moment: moment,
            dateRangeConfig: {
                mode: "range",
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                altInput: true,
                altInputClass: "flatpickr-alt",
                maxDate: moment().format("YYYY-MM-DD"),
            },

            options : {
                year :  [...new Set(Array.from({length:5}, (_,i)=>Math.max(parseInt(moment().format('YYYY'))-i, 2024)))],
                karesidenan : this.$store.getters.getKaresidenan,
                dealer : this.$store.getters.getDealer(),
            },
            selected: {
                date: `${start} to ${end}`,
            },
            filter : {
                start_date: start,
                end_date: end
            },
            custom_filter : {
                distributionProjection : {
                    year: moment().format('YYYY'),
                    kode_dealer: null,
                }
            },

            data : {
                stats : null,
                distributionProjection : null,
            }

        }
    },
    components : {
        deliveryDetailTable,
        distributionProjection,
        distributionSummaryTable,
        mappingDetailTable,
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    mounted () {
        this.fetchData();
    },
    watch : {
        'selected.date'() {
            let dates = this.selected.date.split(' to ');
            this.setUniversalFilter(dates, this);
        },
        'filter' : {
            deep : true,
            handler() {
                this.fetchData('universalFilter')
            }
        },
        'custom_filter.distributionProjection' : {
            deep: true,
            handler() {
                this.fetchData('distributionProjection');
            },
        }
    },
    methods : {
        setUniversalFilter: debounce((dates, vm) => {
            vm.filter.start_date = dates[0];
            vm.filter.end_date = dates[1] ? dates[1] : dates[0];
        }, 2000),
        fetchData(module) {
            //Stats Overview
            if (module == 'stats' || module == 'universalFilter' || module == null) {
                this.$http.get(`/api/qrs/highlight/dealer`, {params: this.filter})
                .then((resp)=>{
                    this.data.stats = resp.data.data;
                })
                .catch((err)=>{console.log(err)})
            }

            // //Distribution Projection
            if (module == 'distributionProjection' || module == 'universalFilter' || module == null) {
                this.$http.get(`/api/qrs/forecast/dealer`, {params: this.custom_filter.distributionProjection})
                .then((resp)=>{
                    let data = resp.data.data;
                    const result = [];
                    const currentDate = moment();

                    // Convert the input data keys to an array of dates
                    const dates = Object.keys(data).map(date => moment(date, "YYYY-MM"));

                    // Iterate over each date to construct the output                
                    dates.forEach((date, index) => {
                        let entry = {
                            date: date.toDate(),
                        };

                        if (date.isBefore(currentDate, 'month')) {
                            entry.pengeluaran = data[date.format("YYYY-MM")].mapping;
                            entry.pemesanan = data[date.format("YYYY-MM")].receipt;
                        } else if (date.isSame(currentDate, 'month')) {
                            entry.pengeluaran = data[date.format("YYYY-MM")].mapping;
                            entry.pemesanan = data[date.format("YYYY-MM")].receipt;
                            entry.projection = data[date.format("YYYY-MM")].receipt;
                        } else {
                            entry.projection = data[date.format("YYYY-MM")].receipt;
                        }

                        result.push(entry);
                    });

                    this.data.distributionProjection = result;
                })
                .catch((err)=>{console.log(err)})
            }
        },
    }
}
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 0;
    }

    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 14px;
        color: black;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 14px;
    }
</style>

<style scoped>
    .stats-row {
        padding: 15px 0 5px;
    }
    .stats-row .col-md:not(:first-child) {
        border-left: 1px solid #ECECEC;
    }
</style>